<ng-container ntapWindowRegistry>
    <ng-container *ngIf="inputConfig$ | async as inputConfig">
        <div class="button-container">
            <div *ngIf="!!readonlyValue && readonlyValue !== '' " style="padding-right: 70px;">
                <ntap-input-label [data]="readonlyValue"></ntap-input-label>
            </div>
            <ntap-show-form-errors [control]="formControl"></ntap-show-form-errors>
            <button ntapDebounceClick  pButton pRipple type="button" class="p-button-rounded p-button-text p-button-success mr-2" pTooltip="Pretraži" icon="pi pi-search" (click)="openDialog()"
                [disabled]="inputConfig.disabled"></button>
            <button ntapDebounceClick  pButton pRipple type="button"pTooltip="Ukloni" class="p-button-rounded p-button-text p-button-danger mr-3" icon="pi pi-times" (click)="clearInputField()"
                [disabled]="inputConfig.disabled"></button>
        </div>
        <p-dialog [(visible)]="dialogVisible" [modal]="true" [draggable]="false" [resizable]="false"
            [style]="{width: '60vw'}" styleClass="p-fluid">
            <ng-container ntapFilterViewProvider [viewName]="currentListViewName">
                <ng-container ntapHierarchyListViewProvider [viewName]="currentListViewName" [viewState]="currentListViewState"  [customSelectableFunction]="customSelectableFn">
                    <ntap-dynamic [compId]="INIT_COMP_ID"></ntap-dynamic>
                </ng-container>
            </ng-container>
            <ng-template pTemplate="footer">
                <button type="button" pButton label="Odaberi" (click)="acceptNode()" [disabled]="isAcceptButtonDisabled$ | async"></button>
            </ng-template>
        </p-dialog>
    </ng-container>
</ng-container>